// the /members query string: search text, selected tag, and the member or room a link points at
export interface MembersQuery {
    query?: string
    tag?: string
    member?: string
    room?: string
}

const QUERY_KEYS: Array<keyof MembersQuery> = ['query', 'tag', 'member', 'room']

export const membersPath = (select: MembersQuery = {}) => {
    const params = new URLSearchParams()
    QUERY_KEYS.forEach((key) => {
        const value = select[key]
        if (value) params.set(key, String(value))
    })
    const search = params.toString()
    return '/members' + (search ? `?${search}` : '')
}

// the parts of a route's query the page reads, so a link can change one and keep the rest
export const membersQueryFrom = (
    base: Record<string, string> | undefined,
): MembersQuery =>
    QUERY_KEYS.reduce<MembersQuery>((memo, key) => {
        const value = base?.[key]
        if (value) memo[key] = value
        return memo
    }, {})

// what typing `text` means next to the current query. A selected tag shows
// in the same input, so the input echoing it back is not a new search (null);
// anything else replaces the search text and drops the tag.
export const typedMembersQuery = (
    current: MembersQuery,
    text: string,
): MembersQuery | null => {
    const trimmed = text.trim()
    if (current.tag && trimmed.toLowerCase() === current.tag.toLowerCase()) {
        return null
    }
    return { ...current, query: trimmed || undefined, tag: undefined }
}
